import {
  getAsync,
  postAsync,
  deleteAsync,
  putAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/exercises";

// GET Exercises for current user paginated, filtered and sorted
export async function getExercisesForCurrentUserAsync(params) {

  var url = `${endpoint}/getExercisesForCurrentUser`;

  var payload = {
    userId: params.userId,
    page: params.page,
    size: params.size,
    sortBy: params.sortBy,
    sortDesc: params.sortDesc[0],
    searchParams: params.searchParams
  };

  return await postAsync(url, payload);
}

// GET Exercises for current user LIGHT paginated, filtered and sorted
export async function GetExercisesForCurrentUserLightAsync(params, needReferenceExercises = false) {

  var url = `${endpoint}/GetExercisesForCurrentUserLight/${needReferenceExercises}`;

  var payload = {
    userId: params.userId,
    page: params.page,
    size: params.size,
    sortBy: params.sortBy,
    sortDesc: params.sortDesc[0],
    searchParams: params.searchParams
  };

  return await postAsync(url, payload);
}

// GET an Exercise by its id
export async function getExerciseByIdAsync(id) {
  return await getAsync(`${endpoint}/${id}`);
}

// GET all PPG Exercises
export async function getPPGExerciseAsyncsAsync() {
  // return await getAsync(`${process.env.VUE_APP_BACKEND}/api/exerciseApps/GetPPG`);
  return await getAsync(`${endpoint}/getPPGExercises`);
}

// GET a PPG Exercise by its id
export async function getPPGExerciseAsync(id) {
  return await getAsync(`${endpoint}/getPPGExerciseById/${id}`);
}

// CREATE a new Exercise
export async function createExerciseAsync(model) {
  return await postAsync(`${endpoint}`, model);
}

// UPDATE an Exercise
export async function updateExerciseAsync(id, model) {
  return await putAsync(`${endpoint}/${id}`, model);
}

// UPDATE ExercisesSets indexes
export async function updateExercisesSetsIndexesAsync(exercisesSets) {
  return await postAsync(`${endpoint}/UpdateExercisesSetsIndexes`, exercisesSets, false);
}

// REMOVE an Exercise from a block
export async function removeExerciseFromBlockAsync(blockId, exerciseId, isPpgExercise) {
  return await deleteAsync(`${endpoint}/RemoveExerciseFromBlock/${blockId}/${exerciseId}/${isPpgExercise}`);
}

// DELETE an Exercise by its id
export async function deleteExerciseAsync(exerciseId) {
  return await deleteAsync(`${endpoint}/${exerciseId}`);
}

// DUPLICATE an Exercise by its id
export async function duplicateExerciseByIdAsync(id) {
  return await getAsync(`${endpoint}/duplicateForUser/${id}`);
}